<template>
  <el-dialog
    class="teacher-dialog"
    title="新建合作信息"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    @close="handleClose">
    <!-- 表单 -->
    <div class="form-container">
      <el-form ref="cooperatorForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="单位名称" prop="unitName">
          <el-input
            v-model="form.unitName"
            placeholder="请输入单位名称"
            maxLength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="单位宣传图片" prop="unitPropagateUrl">
          <div class="flex">
            <upload
              :list="[]"
              :text="'，图片尺寸为270*103px'"
              @childByValue="getPic">
            </upload>
            <img
              class="pic"
              v-show="form.unitPropagateUrl"
              :src="form.unitPropagateUrl">
          </div>
        </el-form-item>
        <el-form-item label="排序号" prop="sortNum">
          <el-input
            v-model="form.sortNum"
            placeholder="请输入排序号">
          </el-input>
          <el-tooltip class="item" effect="dark" content="前端展示按照排序号由大到小顺序排列" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="链接地址" prop="urlLink">
          <el-input
            style="width: 400px"
            v-model="form.urlLink"
            placeholder="请输入链接地址">
          </el-input>
          <p>链接地址必须以http://或者https://开头</p>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit('cooperatorForm', false)">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Upload from '@/components/uploadCopy'
export default {
  components: {
    Upload
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      form: {
        classifyId: '',
        unitName: '',
        unitPropagateUrl: '',
        sortNum: 1,
        urlLink: ''
      },
      rules :{
        unitName: [
          { required: true, message: '单位名称不能为空', trigger: 'blur' },
        ],
        unitPropagateUrl: [
          { required: true, message: '单位宣传图片不能为空', trigger: 'change'}
        ],
        urlLink: [
          { pattern: /(http|https):\/\/[\w]+(.[\w]+)([\w\-\.,@?^=%&:/~\+#\u4e00-\u9fa5]*[\w\-\@?^=%&/~\+#])/, message: '链接地址必须以http://或者https://开头', trigger: 'blur' },
          { max: 200, message: '链接地址不能超过200字符', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    init(data) {
      if (data.id) {
        this.isEdit = true;
        this.form = {
          ...data,
          sortNum: data.sortNum || 1
        };
        return;
      } else {
        this.isEdit = false;
      }
      this.form = {
        classifyId: data.classifyId,
        unitName: '',
        unitPropagateUrl: '',
        sortNum: 1,
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('close');
    },
    // 获取图片
    getPic(file) {
      console.log(file);
      this.form.unitPropagateUrl= file.url;
    },
    // 提交表单/是否预览
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submit', {
            form: this.form,
            isEdit: this.isEdit
          });
          console.log('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
  .teacher-dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        // background-color: #909399;
        padding: 10px;
        .el-dialog__title {
          font-size: 15px;
          // color: #fff;
        }
        .el-dialog__headerbtn {
          top: 10px;
          i {
            // color: #fff;
          }
        }
      }
      .el-dialog__body {
        max-height: 500px;
        overflow-y: scroll;
      }
      .el-form {
        .el-form-item {
          margin-bottom: 25px;
          .el-form-item__error {
            margin: 5px 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-input {
            width: 200px;
          }
        }
        .pic {
          height: 180px;
          object-fit: cover;
          border-radius: 4px;
          margin-left: 15px;
        }
        .el-icon-question {
          font-size: 18px;
          margin-left: 10px;
        }
        .upload {
          // width: 250px;
          height: 200px;
          .el-upload .el-upload-dragger {
            width: 250px;
            height: 160px;
          }
        }
      }
      .el-dialog__footer {
        width: 100%;
        border-top: 1px solid #ddd;
        padding-top: 15px;
      }
    }
  }
</style>